module.exports = __webpack_public_path__ + "static/media/clients-05.df5747cd.svg";